import { Box, ThemeSpaceVariable } from "@caspeco/casper-ui-library";
import { useExternalBookingSettings } from "api/api-hooks/use-external-booking-settings";
import { BookingRequestChildren } from "components/booking-request/booking-request-children";
import SelectGuestsSkeleton from "components/selection-components/select-guests-skeleton";
import { useBookingStateContext } from "hooks/use-booking-state";
import { BookingRequestDate } from "./booking-request-date";
import { SelectRequestGuests } from "./booking-request-guests";

export default function BookingRequestWizard() {
    const externalBookingSettings = useExternalBookingSettings();
    const { guests, guestsChildren } = useBookingStateContext();

    if (externalBookingSettings.isLoading) return <SelectGuestsSkeleton />;
    if (!externalBookingSettings.data) return <SelectGuestsSkeleton />;

    const { activateWebChildren } = externalBookingSettings.data.unitsMetaData;

    return (
        <Box px={ThemeSpaceVariable.Medium}>
            {!guests ? (
                <SelectRequestGuests />
            ) : guestsChildren == null && activateWebChildren ? (
                <BookingRequestChildren />
            ) : (
                <BookingRequestDate />
            )}
        </Box>
    );
}
